import {
  type AIModelChoices,
  AluminiumComposition,
  Annotation,
  EvaluatedSpecification,
  HDPEComposition,
  PETComposition,
} from 'api';

export const MaterialForm = { baled: 'baled', briquette: 'briquette', loose: 'loose' } as const;
export type MaterialForm = keyof typeof MaterialForm;

export interface PreviewGalleryImage {
  src: string;
  feedbackMessages?: string[];
  status?: 'uploading' | 'offline' | 'success' | 'warning' | 'success-warning';
  id?: string;
  message?: string;
  disableDelete?: boolean;
  aluminiumComposition?: AluminiumComposition | null;
  hdpeComposition?: HDPEComposition | null;
  petComposition?: PETComposition | null;
  targetWeightPercentage?: number | null;
  aiModel?: AIModelChoices;
  annotations?: Annotation[];
  evaluatedSpecs?: EvaluatedSpecification[];
}

export enum TiltDirection {
  Up = 'up',
  Down = 'down',
}
